export function defaultPaymentIsExpired(paymentMethods) {
    const expiredPayments = paymentMethods.filter(
        (paymentMethod) => paymentMethod.isDefault() && paymentMethod.isExpired()
    );
    return expiredPayments.length > 0;
}

export function checkBillingAddress(billingAddress) {
    return Boolean(
        billingAddress?.address &&
            billingAddress?.city &&
            billingAddress?.zip_code &&
            billingAddress?.iso_country_code
    );
}

const mapStripeKeyLegalEntityName = {
    HomeExchange_Inc: process.env.HOMEEXCHANGE_INC_STRIPE_KEY,
    HomeExchange_SAS: process.env.HOMEEXCHANGE_SAS_STRIPE_KEY
};

export function getStripeApiKeyByLegalEntityName(legalEntityName) {
    return mapStripeKeyLegalEntityName[legalEntityName] ?? process.env.HOMEEXCHANGE_INC_STRIPE_KEY;
}

export function getPaymentMethodWithAuthorizationRecollection(paymentMethods) {
    return paymentMethods.find(
        (paymentMethod) => paymentMethod.needAuthorizationRecollection() && !paymentMethod.isExpired()
    );
}
